<template>
  <div class="tab-item">
    <div class="grid-bg"></div>
    <div class="grid-item-content">
      <fai class="icon" icon="angle-right"></fai>
      <p v-html="content.text"></p>
      <h2 class="title-font" v-html="content.title"></h2>
    </div>
  </div>
</template>

<script>
import storyblokLink from "@/mixins/storyblokLink";
export default {
  mixins: [storyblokLink],
  props: {
    content: {
      default: null,
      type: Object
    },
    index: {
      default: 0,
      type: Number
    }
  },
  methods: {}
};
</script>

<style lang="scss">

</style>
